var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('material-card',{attrs:{"title":_vm.$t('globals.terms_conditions').toUpperCase(),"color":_vm.$vuetify.theme.themes.light.secondary,"icon":"rule"}},[_c('v-card-text',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.terms)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }